<template>
    <div class="header-div">
        <gift-cert-icon class="h-12 w-12" aria-hidden="true" />
        <div class="title-section">
            <div class="title-wrapper">
                <p>Purchase Gift Certificate</p>
            </div>
            <p>Purchase a gift certificate for a friend or family member.</p>
        </div>
        <button type="button" class="x-icon" aria-label="Close gift certificate purchase" autofocus @click="close">
            <XMarkIcon class="h-5 w-5" aria-hidden="true" />
        </button>
    </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import GiftCertIcon from '~/assets/images/icons/gift-cert-icon.svg';

const emit = defineEmits(['closeDialog']);

const close = () => {
    emit('closeDialog');
};
</script>
<style lang="scss" scoped>
.header-div {
    @apply flex flex-row items-start gap-4 self-stretch;
}
.title-section {
    @apply flex flex-col items-start gap-1 flex-1 relative;

    p {
        @apply text-zinc-600 text-sm font-normal leading-5;
    }
}
.title-wrapper {
    @apply self-stretch flex flex-row justify-between;

    p {
        @apply text-zinc-950 text-lg font-semibold leading-7;
    }
}
// The close control is a real button; the UA chrome is stripped so it renders as the bare icon.
.x-icon {
    @apply w-5 h-5 cursor-pointer top-0 right-0 flex items-center justify-center bg-transparent border-0 p-0;
}
</style>
